import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  dialog: {
    selectors: {
      '& .ms-Dialog-main': {
        minWidth: pxToRem(600),
      },
    },
  },
  dialogContent: {
    padding: pxToRem(20),
  },
  loadingSpinner: {
    marginLeft: pxToRem(10),
  },
  dialogLabel: {
    fontWeight: 'normal',
  },
  search: {
    marginTop: pxToRem(5),
  },
  required: {
    color: theme.palette.red,
  },
});
